import { ChevronDown, ChevronRight } from "lucide-react"
import { Button } from "../ui/button.tsx"
import { motion, AnimatePresence } from "framer-motion"
import { useState } from "react"

export const FAQSection = ({ faqs }) => {
  const [openItem, setOpenItem] = useState(null);

  return (
    <div className="bg-white rounded-lg shadow-sm px-6 py-8">
      <h2 className="text-2xl font-bold text-gray-900 mb-2">Frequently Asked Questions</h2>
      <p className="text-gray-500 mb-8">Find quick answers to common questions about using our platform.</p>
      
      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <div 
            key={index}
            className={`border border-gray-100 rounded-lg transition-all duration-200 ${
              openItem === index ? 'bg-purple-50' : 'hover:bg-gray-50'
            }`}
          >
            <button
              onClick={() => setOpenItem(openItem === index ? null : index)}
              className="w-full px-6 py-4 flex items-center justify-between gap-4 text-left"
            >
              <span className={`font-medium transition-colors ${
                openItem === index ? 'text-purple-700' : 'text-gray-900'
              }`}>
                {faq.question}
              </span>
              <ChevronDown 
                className={`h-5 w-5 flex-shrink-0 transition-transform ${
                  openItem === index ? 'transform rotate-180 text-purple-700' : 'text-gray-400'
                }`}
              />
            </button>
            <AnimatePresence>
              {openItem === index && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: 'auto', opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.2 }}
                  className="overflow-hidden"
                >
                  <div className="px-6 pb-4 text-gray-600 prose-sm">
                    {faq.answer.split('\n').map((line, i) => (
                      <p key={i} className="py-1">
                        {line}
                      </p>
                    ))}
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
      
      <div className="mt-8 flex justify-center">
        <Button 
          variant="outline" 
          className="text-purple-600 border-purple-200 hover:bg-purple-50 hover:border-purple-300 transition-colors"
        >
          View All FAQs <ChevronRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </div>
  )
}
